import { PUBLIC_EMAIL_DOMAINS } from '@/config/amplify';
import { UserType } from '@/types/modelEnums';

/** The only account types a user may give themselves; every other type is operator-set. */
export const SELF_SERVICE_USER_TYPES = [UserType.PATIENT, UserType.PROVIDER] as const;

export type SelfServiceUserType = (typeof SELF_SERVICE_USER_TYPES)[number];

export function isSelfServiceUserType(value: unknown): value is SelfServiceUserType {
  return SELF_SERVICE_USER_TYPES.some(type => type === value);
}

/** True for a public mail provider's domain, which sign-up and the type route refuse a Provider. */
export function isPublicEmailDomain(email: string): boolean {
  const domain = email.split('@')[1]?.trim().toLowerCase();
  return !!domain && PUBLIC_EMAIL_DOMAINS.includes(domain);
}

/** A Provider needs an email with an institutional domain; a Patient needs nothing. */
export function mayChooseUserType(type: SelfServiceUserType, email: string | undefined): boolean {
  if (type !== UserType.PROVIDER) return true;
  if (!email?.split('@')[1]?.trim()) return false;
  return !isPublicEmailDomain(email);
}

export function userTypeOptionsFor(email: string | undefined): SelfServiceUserType[] {
  return SELF_SERVICE_USER_TYPES.filter(type => mayChooseUserType(type, email));
}
